import { forEach, isElement } from 'lodash';
import mustache from 'mustache';

import { getLocalStorage } from '../../01-helpers/session-manager';


const 
	moduleName = 'receipt',
	selectors = {
		base: `.js-${moduleName}`,
		container: `.js-${moduleName}__container`,
		template: '#receiptTemplate'
	};


export default class Receipt {
	constructor(baseElement) {
		this.baseElement = baseElement;

		this._onLoad();
	}

	_onLoad() {
		const receiptData = getLocalStorage('TeeTime'),
			container = this.baseElement.querySelector(selectors.container),
			resultTemplate = this.baseElement.querySelector(selectors.template).innerHTML;

		container.insertAdjacentHTML('beforeBegin', mustache.render(resultTemplate, receiptData));
	}
}

const initReceipt = () => {
	forEach(document.querySelectorAll(selectors.base), element => {
		const receipt = new Receipt(element);
	});
}

initReceipt();